import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Blogs from "./pages/Blogs";
import Services from "./pages/Services";
import ContactUs from "./pages/ContactUs";
import Wishlist from "./pages/Wishlist";
import Hotels from "./pages/Hotels";
import HotelSearch from "./pages/HotelSearch";
import HotelDetail from "./pages/HotelDetail";
import RoomDetail from "./pages/RoomDetail";
import DestinationDetails from "./pages/DestinationDetails";
import LoginModal from "./components/LoginModal";
import { useState, useEffect } from "react";
import Profile from "./pages/Profile";
import BlogDetail from "./pages/BlogDetail";
import ScrollToTop from "./components/ScrollToTop";
import NotFound from "./pages/NotFound";
import PaymentPage from "./pages/PaymentPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import VerifySubscription from "./pages/VerifySubscription";
import UnsubscribeSubscription from "./pages/UnsubscribeSubscription";
import Faqs from "./pages/Faqs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import ProtectedRoute from "./components/ProtectedRoute";
import DestinationsList from "./pages/DestinationsList";


function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [user, setUser] = useState(null);

  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const storedUser = localStorage.getItem("user");

    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }

    setLoading(false); // ✅ important
  }, []);

  if (loading) {
    return null; // or a loader spinner
  }


  return (
    <GoogleReCaptchaProvider reCaptchaKey="6LfNusAsAAAAAN6CtHqeIFHawHrLCqTlDXK88kk5">
      <BrowserRouter>
        <ScrollToTop />

        <Header user={user} setUser={setUser} onLoginClick={() => setIsModalOpen(true)} />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hotels" element={<Hotels />} />
          <Route path="/search-hotels" element={<HotelSearch />} />
          {/* <Route path="/hotels/:id" element={<HotelDetail />} /> */}

          <Route path="/hotels/:slug" element={<HotelDetail />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/wishlist" element={<Wishlist />} />
          {/* <Route path="/rooms/:id" element={<RoomDetail />} /> */}

          <Route path="/hotels/:hotelSlug/:roomId" element={<RoomDetail />} />

          <Route path="/destinations/:slug" element={<DestinationDetails />} />
          <Route
            path="/profile"
            element={
              <ProtectedRoute user={user}>
                <Profile onLoginClick={() => setIsModalOpen(true)} />
              </ProtectedRoute>
            }
          />
          <Route path="/blogs/:slug" element={<BlogDetail />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/payment-success" element={<PaymentSuccess onLoginClick={() => setIsModalOpen(true)} />} />
          <Route path="/payment-cancel" element={<PaymentCancel />} />
          <Route path="/verify-subscription/:token" element={<VerifySubscription />} />
          <Route path="/unsubscribe/:token" element={<UnsubscribeSubscription />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/destinations" element={<DestinationsList />} />
        </Routes>

        <LoginModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} setUser={setUser} />

        <Footer />
      </BrowserRouter>
    </GoogleReCaptchaProvider>
  );
}

export default App;